"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { useAppDispatch } from "@/redux/hooks";
import { fetchIpInfo } from "@/redux/slices/network.slice";

/**
 * Re-check network classification on page entry. The Redux thunk enforces a
 * five-minute success/error TTL, so client navigation never becomes polling.
 */
export default function NetworkInfoProvider({ children }) {
  const dispatch = useAppDispatch();
  const pathname = usePathname();

  useEffect(() => {
    // Start on mount/page entry for every visitor. The RTEM request receives a
    // token from its shared client when one exists; the public race never does.
    dispatch(fetchIpInfo());
  }, [dispatch, pathname]);

  return children;
}
